import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { BrowserCommonUiModule } from '@assess/browser/common-ui';

import { HydraConfig, IHydraConfig } from './hydra.config';
import { HydraDirective } from './hydra.directive';

@NgModule({
  declarations: [HydraDirective],
  exports: [HydraDirective],
  imports: [BrowserCommonUiModule, MatDialogModule],
})
export class HydraModule {
  constructor(@Optional() @SkipSelf() hydraModule: HydraModule) {
    if (hydraModule) {
      throw new Error(`${HydraModule.name} is already loaded. Import the module once in the root of the application.`);
    }
  }

  static forRoot(config: IHydraConfig) {
    return {
      ngModule: HydraModule,
      providers: [{ provide: HydraConfig, useValue: config }],
    };
  }
}
